import { handleResponse, usePostApiDataPrivacySiteRevokeByTokenMutation } from '@lib/api';
import { useNavigate, useParams } from 'react-router';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

export function RevokeRoute() {
  const { t } = useTranslation('data_privacy');
  const navigate = useNavigate();
  const { token } = useParams() as { token: string };
  const [postRevoke] = usePostApiDataPrivacySiteRevokeByTokenMutation();

  const revokeAccount = async () => {
    const response = await postRevoke({ token });
    handleResponse(
      response,
      (error) => {
        if (error.status === 404) {
          toast.error(t('consent.revoke.token_not_found'));
        } else {
          toast.error(t('consent.revoke.error'));
        }
      },
      () => {
        navigate('/data-privacy-revocation-success');
      },
    );
  };

  return (
    <div className="w-full max-w-2xl text-white px-4">
      <h1 className="text-md mt-16 opacity-75 capitalize">{t('consent_declaration')}</h1>
      <h2 className="font-bold text-4xl mb-8">{t('consent.revoke_heading')}</h2>
      <p className="mb-8">{t('consent.revoke_text')}</p>

      <div className="modal-footer-save min-w-55" onClick={revokeAccount}>
        {t('consent.revoke_button')}
      </div>
    </div>
  );
}

export default RevokeRoute;
